import GoodForSelector from './goodForSelector'

export default GoodForSelector